module.exports = __webpack_public_path__ + "static/img/OOSH_057.ef88e76.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/photos/OOSH_057.jpg
// module id = 5YYi
// module chunks = 170